import { render, staticRenderFns } from "./treatment_params.vue?vue&type=template&id=4fb40a72&scoped=true"
import script from "./treatment_params.vue?vue&type=script&lang=js"
export * from "./treatment_params.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb40a72",
  null
  
)

export default component.exports